import axios from '@axios'
import { currencyInt, formatDateBr, formatDateTimeBr } from '@core/utils/filter'
import { getUserData } from '@/auth/utils'

export default {
  namespaced: true,
  state: {
    pedido: {},
    pedidos: [],
  },
  getters: {
    GET_PEDIDO: state => state.pedido,
    GET_PEDIDOS: state => state.pedidos,
    GET_FIELDS_PEDIDO: state => {
      const dataPedido = state.pedido
      const fieldsExcel = {
        Codigo: 'id',
        'Order ID': 'order_id',
        Cliente: 'cliente.nome',
        CPF: 'cliente.documento',
        'E-mail': 'cliente.usuarios.0.login',
        Status: {
          field: 'status',
          callback: value => {
            if (value === 'Canceled') return 'Cancelado'
            if (value === 'Failed') return 'Falhou'
            if (value === 'Waiting_Payment') return 'Aguardando pagamento'
            if (value === 'Paid') return 'Pago'
            if (value === 'Expired') return 'Expirado'
            return 'Pendente'
          },
        },
        'Número da NF-e': 'bling_numero_nfe',
        'Metodo de Pagamento': {
          field: 'metadata.payment_method',
          callback: value => {
            if (value === 'CREDIT_CARD') return 'Cartão de crédito'
            if (value === 'PIX') return 'PIX'
            if (value === 'BOLETO') return 'Boleto'
            return 'Não identificado'
          },
        },
        'Data Venda': {
          field: 'data_venda',
          callback: value => formatDateBr(value),
        },
        'Data Criação': {
          field: 'data_inclusao',
          callback: value => formatDateTimeBr(value),
        },
        'Valor Total': {
          field: 'valor_total_pedido',
          callback: value => currencyInt(value),
        },
        'Nome do Estudante 1': {
          field: 'metadata.students',
          callback: students => students[0]?.name_student || '',
        },
        'Turma do Estudante 1': {
          field: 'metadata.students',
          callback: students => students[0]?.turma_student || '',
        },
        'Unidade do Estudante 1': {
          field: 'metadata.students',
          callback: students => students[0]?.unidade_student || '',
        },
        'Nome do Estudante 2': {
          field: 'metadata.students',
          callback: students => students[1]?.name_student || '',
        },
        'Turma do Estudante 2': {
          field: 'metadata.students',
          callback: students => students[1]?.turma_student || '',
        },
        'Unidade do Estudante 2': {
          field: 'metadata.students',
          callback: students => students[1]?.unidade_student || '',
        },
        'Nome do Estudante 3': {
          field: 'metadata.students',
          callback: students => students[2]?.name_student || '',
        },
        'Turma do Estudante 3': {
          field: 'metadata.students',
          callback: students => students[2]?.turma_student || '',
        },
        'Unidade do Estudante 3': {
          field: 'metadata.students',
          callback: students => students[2]?.unidade_student || '',
        },
      }
      return fieldsExcel
    },
  },
  mutations: {
    SET_PEDIDO: (state, payload) => {
      state.pedido = payload
    },
    SET_PEDIDOS: (state, payload) => {
      state.pedidos = payload
    },
  },
  actions: {
    findAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        // Obter dados do usuário logado
        const userData = getUserData()
        // Verificar se o usuário é vendedor e tem ID
        const idVendedor = userData?.vendedor?.id
        if (!idVendedor && userData?.id_grupousuario !== 1) { // Se não for vendedor e nem admin
          return reject(new Error('ID do vendedor não encontrado'))
        }
        // Construir URL com o ID do vendedor (se não for admin)
        const url = `/pedidos/vendedor/${idVendedor}`

        axios
          .get(url, { params: queryParams })
          .then(response => {
            ctx.commit('SET_PEDIDOS', response.data.abilities)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    findById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/pedidos/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    findAllAdmin(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/pedidos', { params: queryParams })
          .then(response => {
            ctx.commit('SET_PEDIDOS', response.data.abilities)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    create(ctx, dataCreate) {
      return new Promise((resolve, reject) => {
        axios
          .post('/pedidos', dataCreate)
          .then(response => resolve(response))
          .catch(error => {
            reject(error)
          })
      })
    },
    update(ctx, dataUpdate) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/pedidos/${dataUpdate.id}`, {
            ...dataUpdate,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    delete(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/pedidos/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    gerarEtiquetaCorreios(ctx, { pedidoId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/correios/pedido/${pedidoId}/etiqueta`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadEtiquetaPdf(ctx, { idPrePostagem }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/correios/etiqueta/${idPrePostagem}/pdf`, { responseType: 'arraybuffer' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    rastrearEncomenda(ctx, { codigoRastreio }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/correios/rastrear/${codigoRastreio}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getEtiquetaLocalHtml(ctx, { pedidoId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/correios/pedido/${pedidoId}/etiqueta-local`, { responseType: 'text' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
